import { SparePartReturnProcess } from '@savgroup-front-common/types';

import sparePartReturnProcessMessages from '../helpers/i18n/messages/sparePartReturnProcessMessages';

import { safeFormattedIntlString } from './safeFormattedIntlString';

const getSparePartReturnProcessMessages = (
  value: SparePartReturnProcess,
): ReturnType<typeof safeFormattedIntlString> => {
  let message;

  switch (value) {
    case SparePartReturnProcess.DEEE: {
      message = sparePartReturnProcessMessages.DEEE;
      break;
    }
    case SparePartReturnProcess.MANUFACTURER: {
      message = sparePartReturnProcessMessages.Manufacturer;
      break;
    }
    case SparePartReturnProcess.NONE: {
      message = sparePartReturnProcessMessages.None;
      break;
    }
    default:
      throw new Error(`Spare parts return process ${value} does not exist`);
      break;
  }

  return safeFormattedIntlString(message);
};

export default getSparePartReturnProcessMessages;
